if( 'ontouchstart' in window ) {
	document.body.classList.add( 'HAS-touch' );
} else {
	document.body.classList.add( 'NO-touch' );
}
(function(){




//	Variable decalrations
var viewerUnderlay     = document.createElement('div');
var	viewerImgContainer = document.createElement('div');
var	viewerImg          = document.createElement('img');
var viewerSpeed        = 0.5;

var imageBounds;



viewerUnderlay.className     = 'imageViewer';
viewerImgContainer.className = 'imageViewerImageContainer';
viewerImg.className          = 'imageViewerImage';



viewerImgContainer.appendChild( viewerImg );
document.body.appendChild( viewerUnderlay );
document.body.appendChild( viewerImgContainer );

viewerImgContainer.style.transitionDuration = viewerSpeed + 's';
viewerUnderlay.style.transitionDuration = viewerSpeed + 's';

//	Add viewer to all created sites
Array.prototype.forEach.call( document.querySelectorAll('.builtSite'), attachViewerToElement );





//	Functions
function attachViewerToElement ( attachedTo_elt ) {

	var clickedImage             = attachedTo_elt;
	var clickedImageIllustration = clickedImage.querySelector( '.builtSite__image' );
	var imgBackgroundImage       = clickedImageIllustration.style.backgroundImage;
	var src                      = imgBackgroundImage.slice(
			imgBackgroundImage.indexOf('(') + 1,
			imgBackgroundImage.lastIndexOf(')')
		).replace(/['"]+/g, '');
	var src_big                  = src.replace( /(\.\w{3,4})$/, '-big$1' );
	var imagePreloader = new Image();

	//	Preload the full preview
	imagePreloader.src = src_big;
	attachedTo_elt.addEventListener( 'click', openInViewer, false );

	function openInViewer ( e ) {
		e.preventDefault();

		imageBounds = clickedImage.getBoundingClientRect();

		viewerImg.src = src_big;

		viewerImgContainer.style.top        = imageBounds.top + 'px';
		viewerImgContainer.style.left       = imageBounds.left + 'px';
		viewerImgContainer.style.width      = imageBounds.width + 'px';
		viewerImgContainer.style.height     = imageBounds.height + 'px';
		viewerImgContainer.style.display = 'block';


		viewerUnderlay.style.display = 'block';
		document.body.style.overflow = 'hidden';

		setTimeout( centerViewerImage, 4 );

		viewerImgContainer.addEventListener('click', closeViewer, false);
		viewerUnderlay.addEventListener('click', closeViewer, false);

	}

	function centerViewerImage () {
		setTransitions();

		viewerImgContainer.style.top    = '5%';
		viewerImgContainer.style.left   = '5%';
		viewerImgContainer.style.width  = '90%';
		viewerImgContainer.style.height = '90%';
		viewerImgContainer.style.opacity = 1;

		viewerUnderlay.style.opacity = '0.9';
	}

	function closeViewer () {
		viewerImgContainer.removeEventListener('click', closeViewer, false);
		viewerUnderlay.removeEventListener('click', closeViewer, false);



		viewerImgContainer.scrollTop  = 0;
		viewerImgContainer.scrollLeft = 0;

		viewerImgContainer.style.top        = imageBounds.top + 'px';
		viewerImgContainer.style.left       = imageBounds.left + 'px';
		viewerImgContainer.style.width      = imageBounds.width + 'px';
		viewerImgContainer.style.height     = imageBounds.height + 'px';
		viewerImgContainer.style.opacity = 0;

		viewerUnderlay.style.opacity = 0;

		document.body.style.overflow = 'auto';



		setTimeout( hideViewer, viewerSpeed*1000 );
	}

	function hideViewer () {
		viewerImgContainer.style.display = 'none';
		viewerUnderlay.style.display = 'none';

		imageBounds = undefined;

		unsetTransitions();
	}

	function setTransitions () {
		viewerUnderlay.style.transitionProperty     = 'opacity';
		viewerImgContainer.style.transitionProperty = 'top, left, width, height, opacity';
	}

	function unsetTransitions () {
		viewerUnderlay.style.transitionProperty     = 'none';
		viewerImgContainer.style.transitionProperty = 'opacity';
	}



}





}());

//	PLUGIN -- BRK_Carousel

(function( document, window, undefined ){

window.brk = window.brk || {};

brk.carousel = BRK_carousel;




//	Functions

function BRK_carousel ( options ) { // CLOSURE BEGIN -- setCarousel

//	Variables
var o = options || {};

//	 - Element class names
var carousel_class = 'carousel';
var viewFinder_class = 'viewFinder';
var film_class = 'film';
var item_class = 'item';
var itemFocus_class = 'item--focused';

//	 - DOM Elements
//	The container for all of the carousel parts.
var carousel_elt = document.querySelector( '.' + carousel_class );
//	A box the same size as an item which is always
//		in the same position as the current item.
var viewFinder_elt = carousel_elt.querySelector( '.' + viewFinder_class );
//	The container element for all of the items.
//	This film is 'threaded' through the viewfinder.
var film_elt = viewFinder_elt.querySelector( '.' + film_class );
//	The items.
var item_elts = film_elt.querySelectorAll( '.' + item_class );

//	 - Simulation data
var w = o.width || 100;
var n = item_elts.length;
var i = 0;



setActiveClass();
viewFinder_elt.style.width = w + 'px';
film_elt.style.width       = ( w*n ) + 'px';
Array.prototype.forEach.call( item_elts, function ( item_elt ) {
	item_elt.style.width = w + 'px';
});


//	Return
return {
	inc: incrementPosition.bind( null, false ),

	next: function(){
		incrementPosition();
	},
	nextSet: nextSet,

	prev: function(){
		incrementPosition({
			by: -1
		});
	},
	prevSet: previousSet,

	goto: incrementPosition.bind( null, true ),

	get: {
		position: function(){ return i },
		count:    function(){ return n }
	}
}

//	Functions
function incrementPosition ( options ) {
	var o = options || {};

	var explicit = o.explicit || false;
	var by       = o.by        || 1;
	var overflow = o.overflow || 'wrap';


	removeActiveClass();

	//  Make sure by is an integer
	by = parseInt( by, 10 );

	//	Increment the film as desired
	if ( explicit ) {
		i = by;
	} else {
		i += by;
	}

	settlePosition( overflow );

	//	Move the film elements to their new positions
	renderFilm();
}

function nextSet () {
	var carouselWidth = carousel_elt.getBoundingClientRect().width;
	var incBy = Math.max( 1, Math.floor( carouselWidth / w ) );

	incrementPosition({
		by:       incBy,
		overflow: 'stop'
	});
}

function previousSet () {
	var carouselWidth = carousel_elt.getBoundingClientRect().width;
	var incBy = Math.max( 1, Math.floor( carouselWidth / w ) );

	incrementPosition({
		by:       -incBy,
		overflow: 'stop'
	});
}

function settlePosition ( overflow ) {

	if ( overflow === 'wrap' ) {
		//	Make sure the position is positive
		while ( i < 0 ) {
			i += n;
		}

		//	Make sure the number isn't too big
		i = i%n;
	} else if ( overflow === 'stop' ) {
		i = Math.max( 0, Math.min( i, n-1 ) )
	}

	else{
		alert('broken');
	}
}

//	Style the film elements to represent the data
function renderFilm () {
	setActiveClass();

	film_elt.style.left = -( i*w ) + 'px';

	viewFinder_elt.style.left = ( i*( 1/( n - 1 ) ) )*100 + '%';
	viewFinder_elt.style.marginLeft = -( i*( 1/( n - 1 ) ) )*w + 'px';
}

//	Remove the active class from all items
function removeActiveClass () {
	Array.prototype.forEach.call(
		film_elt.querySelectorAll( '.' + itemFocus_class ),
		function ( item_elt ) {
			item_elt.classList.remove( itemFocus_class );
		}
	);
}

//	Add the active class to the currently active item
function setActiveClass () {
	item_elts[ i ].classList.add( itemFocus_class );
}

} // CLOSURE END -- setCarousel







}( document, window ));
/*
(function(){"use strict";



var imgs = document.querySelectorAll( '[style]' );

Array.prototype.forEach.call( imgs, upgradeImages );



//	Functions
function upgradeImages ( elt ) {
	var imageURL = elt.style.backgroundImage;

	if ( imageURL.indexOf( '-sml.' ) > -1 ) {
		loadImage( elt, imageURL );
	}
};

function loadImage ( elt, imageURL ) {
	elt.classList.add( 'brk-enhancing' );

	var image = new Image();
	var newImageURL = imageURL
		.match( /url\('?"?([^)'"]+)'?"?\)/ )[1]
		.replace( '-sml.', '.' );

	image.addEventListener( 'load', replaceImage, false );
	image.src    = newImageURL;



	//	Functions
	function replaceImage () {
		elt.classList.remove( 'brk-enhancing' );

		elt.style.backgroundImage = 'url(' + newImageURL + ')';
	}
}



}());
*/
(function(){"use strict";



var headLogo_elt = document.querySelector( '.headLogo' );
var stall;

setLogoSize();
window.addEventListener( 'scroll', stallLogoResize, false );

function stallLogoResize () {
	if ( stall ) {
		clearTimeout( stall );
	}

	stall = setTimeout( setLogoSize, 300 );
}

function setLogoSize ( e ) {
	stall = false;

	if( scrollY > 25 ) {
		headLogo_elt.classList.add( 'headLogo--fit' );
	} else {
		headLogo_elt.classList.remove( 'headLogo--fit' );
	}
}



}());
(function(){"use strict";



var mainHeadContainer_elt = document.querySelector( '.mainHeadContainer' );
//	Setting this to infinity ensures the header isn't hidden on page load
var prevScroll = Infinity;

var showMargin_top = 60;
var showMargin_bottom = 60;

window.addEventListener( 'scroll', setHeadDisplay, false );

function setHeadDisplay () {
	//	If we're:
	//	 -	scrolling up
	//	 -	near the top
	//	 -	near the bottom
	//	then show the header
	if ( scrollY < prevScroll  ||  scrollY < showMargin_top  || scrollY > getDocHeight() - innerHeight - showMargin_bottom ) {
		mainHeadContainer_elt.classList.remove( 'mainHeadContainer--hidden' );

	} else {
		mainHeadContainer_elt.classList.add( 'mainHeadContainer--hidden' );
	}

	//	Reset the previous scroll variable
	prevScroll = scrollY;
}

function getDocHeight () {
	return Math.max( document.body.scrollHeight, document.body.offsetHeight,
	                 document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight );
}



}());
(function(){"use strict";



var menuToggleContainer_elt = document.querySelector('.menuToggle');
var pageTitle_elt = document.querySelector('.pageTitle');


menuToggleContainer_elt.addEventListener( 'click', toggleMenuDisplay, false );



//	Functions
function toggleMenuDisplay ( e ) {
	menuToggleContainer_elt.classList.toggle( 'menuToggle--open' );
	pageTitle_elt.classList.toggle( 'pageTitle--hidden' );
}



}());
(function(){



var prev_elt  = document.querySelector( '.carouselPrev' );
var next_elt  = document.querySelector( '.carouselNext' );
var container_elt  = document.querySelector( '.carouselContainer' );

var carousel = brk.carousel({
	width: 200
});

prev_elt.addEventListener( 'click', goToPreviousPosition, false );
next_elt.addEventListener( 'click', goToNextPosition, false );

setClasses();
container_elt.classList.remove( 'carouselContainer--inactive' );


//	FUNCTIONS

function goToPreviousPosition () {
	carousel.prevSet();

	setClasses();
}

function goToNextPosition () {
	carousel.nextSet();

	setClasses();
}

function setClasses () {

	prev_elt.classList.remove( 'carouselPrev--disabled' );
	next_elt.classList.remove( 'carouselPrev--disabled' );

	if ( carousel.get.position() === 0 ) {
		prev_elt.classList.add( 'carouselPrev--disabled' );
	}

	if ( carousel.get.position() === carousel.get.count()-1 ) {
		next_elt.classList.add( 'carouselPrev--disabled' );
	}
}



}());
(function(){



//



}())
//# sourceMappingURL=main.21.js.map